<template>
    <card-wrapper :title="Lang.get('employerdashboard::pages/employee/deposits.create.title', { 'full_name': employee.fullname })"
                  :subtitle="Lang.get('employerdashboard::pages/employee/deposits.create.subtitle')">

        <template v-slot:nav aria-label="breadcrumb">
            <ol class="breadcrumb font-poppins font-weight-light font-size-14 color-blue px-0 bg-white">
                <li class="breadcrumb-item">
                    <a
                        :href="route('nl.employerdashboard.employees.overview', $page.props.auth.user.selected_company.uuid)"
                        class="font-poppins font-weight-semibold color-blue">
                        {{ Lang.get('employerdashboard::pages/employee/breadcrumb.overview') }}</a>
                </li>
                <li class="breadcrumb-item">
                    <a
                        :href="route('nl.employerdashboard.employee.profile', {company_as_uuid: $page.props.auth.user.selected_company.uuid, employee_uuid: employee.uuid})"
                        class="font-poppins font-weight-semibold color-blue">
                        {{ Lang.get('employerdashboard::pages/employee/breadcrumb.profile') }}</a>
                </li>
                <li class="breadcrumb-item">
                    <a
                        :href="route('nl.employerdashboard.employee.deposits', {company_as_uuid: $page.props.auth.user.selected_company.uuid, employee_uuid: employee.uuid})"
                        class="font-poppins font-weight-semibold color-blue">
                        {{ Lang.get('employerdashboard::pages/employee/breadcrumb.deposits') }}</a>
                </li>
                <li class="breadcrumb-item color-blue" aria-current="page">
                    {{ Lang.get('employerdashboard::pages/employee/breadcrumb.create_budget_deposit') }}
                </li>
            </ol>
        </template>

        <div class="col-12 col-md-8">
            <flash-messages :hide-errors="true"></flash-messages>
        </div>

        <card-layout :size="'large'" :card_padding="'p-4'">

            <form @submit.prevent="submit">
                <div class="form-row">
                    <div class="form-group col-md-10">
                        <text-input
                            v-model="form.amount"
                            :label="Lang.get('employerdashboard::shared.amount')"
                            :placeholder="Lang.get('employerdashboard::shared.placeholder.amount')"
                            :error="errors.amount"
                            :isValidated="isValidated"
                        />
                    </div>
                </div>
                <div class="form-row" v-if="conditions.isTermsOfUse">
                    <div class="form-group col-md-10">
                        <label class="font-poppins color-dark-blue">{{
                                Lang.get('employerdashboard::pages/employee/deposits.create.labels.terms_of_use', {'file_name':conditions.termsOfUseFile})
                            }}:</label>
                        <br/>
                        <label class="font-poppins color-dark-blue">{{
                                Lang.get('employerdashboard::pages/employee/deposits.create.labels.agree')
                            }}:</label>
                        <input class="font-poppins color-dark-blue" type="radio" value="true"
                                   v-model="form.terms_of_use">

                        <label class="font-poppins color-dark-blue">{{
                                Lang.get('employerdashboard::pages/employee/deposits.create.labels.not_agree')
                            }}:</label>
                        <input class="font-poppins color-dark-blue" type="radio" value="false"
                                   v-model="form.terms_of_use">
                        <form-error :error="errors.terms_of_use"></form-error>
                    </div>
                </div>

                <div class="form-row mt-3">
                    <div class="form-group col-12 col-md-4 col-lg-3 mt-3">
                        <button
                            class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4">
                            {{ Lang.get('employerdashboard::shared.save') }}
                        </button>
                    </div>
                </div>
            </form>
        </card-layout>
    </card-wrapper>
</template>

<script>
import CardWrapper from '@/Shared/CardWrapper'
import CardLayout from "@/Shared/CardLayout";
import TextInput from "@/Shared/TextInput";
import SelectInput from "@/Shared/SelectInput";
import FormError from "@/Shared/FormError";
import EmployeeEditConfirmationModal from "@/Shared/EmployeeEditConfirmationModal";
import FlashMessages from "@/Shared/FlashMessages";

export default {
    metaInfo() {
        return {
            title: `${this.Lang.get('employerdashboard::pages/employee/deposits.create.title', { 'full_name': this.employee.fullname })}`,
        }
    },
    components: {
        CardWrapper,
        CardLayout,
        EmployeeEditConfirmationModal,
        FormError,
        SelectInput,
        TextInput,
        FlashMessages,
    },
    props: {
        errors: Object,
        conditions: Object,
        employee: Object,
        isValidated: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },

    data() {
        return {
            showInstructions: false,
            contract: false,
            form: {
                amount: null,
                terms_of_use: this.conditions.isTermsOfuse,
            },
        }
    },

    methods: {
        submit() {
            this.$inertia.post(this.route('nl.employerdashboard.employee.create.budget.deposit.attempt', {
                'company_as_uuid': this.$page.props.auth.user.selected_company.uuid,
                'employee_uuid': this.employee.uuid
            }), this.form);
        },
    },
}
</script>
